import { Label } from "../ui/label";
import Select, { components } from "react-select";
import "react-select-search/style.css";

export default function AppSearchSectionSelect({
    value,
  onChange = () => {},
    placeholder,
    data = [],
    label,
    labelButton,
    //style,
    style = {},  //   style={{ border: "2px solid red", backgroundColor: "#f5f5f5" }}
    className,
    disabled = false,
    isMulti=false
}) {
  const options = [
    // { name: "Swedish", value: "sv" },
    // { name: "English", value: "en" },
    {
      type: "group",
      name: "Group name",
      items: [{ name: "Spanish", value: "es" }],
    },
  ];

    const OptionComponent = ({ data, ...props }) => {
    //const Icon = data.icon;

        return (
            <components.Option {...props}>
                <div className="flex items-center gap-2">{data.label}</div>
            </components.Option>
        );
    };

    return (
        <div className={className}>
      {/* <div className="flex justify-between"> */}
            {label && (
                <Label className="mb-2" htmlFor="inputId">
                    {label}
                </Label>
            )}
            {labelButton && labelButton()}
      {/* </div> */}

            <Select
                options={data}
                className="react-select"
                classNamePrefix="select"
                value={value}
                onChange={(val) => {
                    onChange(val);
                }}
                isMulti={isMulti}        
                closeMenuOnSelect={!isMulti} 
                components={{
                    Option: OptionComponent,
                }}
                styles={{
                    menu: (provided) => ({
                        ...provided,
                        maxHeight: "180px",
                        overflowY: "auto",
                     
                    }),
                    menuList: (provided) => ({
                        ...provided,
                        maxHeight: "180px",
                        overflowY: "auto",
                       
                    }),
                    control: (provided) => ({
                        ...provided,
                        ...style,
                    }),
                }}
                menuPlacement="auto" // Changed from "top" to "auto" for default behavior
                isDisabled={disabled}
                placeholder={placeholder}
            />

      {/* <SelectSearch
        options={data}

        search
        value={value}
        onChange={onChange}
        name="language"
        // className={"container"}
        placeholder={placeholder}
      /> */}
        </div>
    );
}
